// Where the Usage demo lives: under the superadmin demo routes like the other
// in-app demos, behind the "Usage" toggle in the Super Admin menu.

export const USAGE_PATH = "/superadmin/demo/usage";
export const USAGE_PIPELINE_PATH = `${USAGE_PATH}/pipeline`;
export const USAGE_PORTFOLIO_PATH = `${USAGE_PATH}/portfolio`;

export const usageDealPath = (dealId: string) => `${USAGE_PORTFOLIO_PATH}/deals/${dealId}`;
/** The project page, optionally opened on a stage ("usage", or "usage&rev=2"). */
export const usageProjectPath = (projectId: string, stage?: string) =>
    `${USAGE_PATH}/project/${projectId}${stage ? `?stage=${stage}` : ""}`;
